import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7980914e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { name: "cardForm" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Drag decks around to change the order they appear in for the default sort.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IonLabel = _resolveComponent("IonLabel")!
  const _component_IonItem = _resolveComponent("IonItem")!
  const _component_IonReorder = _resolveComponent("IonReorder")!
  const _component_IonReorderGroup = _resolveComponent("IonReorderGroup")!
  const _component_IonList = _resolveComponent("IonList")!
  const _component_IonButton = _resolveComponent("IonButton")!
  const _component_ModalPattern = _resolveComponent("ModalPattern")!

  return (_openBlock(), _createBlock(_component_ModalPattern, {
    title: "Reorder Decks",
    dismiss: _ctx.dismiss
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_IonList, { "radio-group": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_IonReorderGroup, {
              disabled: false,
              onIonItemReorder: _ctx.handleMoveDeck
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.decks, (deck) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: deck.id
                  }, [
                    _createVNode(_component_IonReorder, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_IonItem, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_IonLabel, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(deck.title) + " – " + _toDisplayString(deck.cards?.length ? deck.cards?.length === 1 ? '1 card' : `${deck.cards.length} cards` : 'No cards'), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["onIonItemReorder"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_IonButton, {
          fill: "solid",
          color: "primary",
          id: "save",
          onClick: _ctx.dismiss
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Done ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["dismiss"]))
}